import { useMutation } from '@tanstack/react-query';
import { fetchPassKeyLogin } from './service';
import { UsePassKeyLoginProps } from './props';
import { useLoginCallback } from '@/hooks/useLogInCallback';
import { LoginByEmailSuccessOutputDto } from '@starsoft/common/dto';

export function usePassKeyLogin(props?: UsePassKeyLoginProps) {
  const { externalOnSuccess: externalSuccess }: UsePassKeyLoginProps =
    props ?? {};
  const login = useLoginCallback();
  const { mutate, isPending, isSuccess } = useMutation({
    mutationFn: fetchPassKeyLogin,
    onSuccess: data => {
      login(data as LoginByEmailSuccessOutputDto);
    },
  });

  return {
    passKeyLogin: mutate,
    isPending,
    isSuccess,
  };
}
